import { useState } from "react";

import { useMutation } from "react-query";
import axiosInstance from "../../services/axiosInstance";
import { OkCancelPopup } from "../../components/modal/OkCancelPopup";
import { icQuestion } from "../../components/image/image-src";
import { usePopup } from "../../hooks/usePopup";
import { useTranslation } from "react-i18next";

export default function DeleteAccount() {
  const { t } = useTranslation();

  const [isChecked, setIsChecked] = useState(false);

  const mutation = useMutation({
    mutationFn: async () => {
      const token = localStorage.getItem("token");
      return axiosInstance.post("/auth/delete", {
        token,
      });
    },
    onSuccess: () => {
      alert("Your account has been deleted successfully.");
      localStorage.removeItem("token");
      window.location.href = "/";
    },
    onError: () => {
      alert("Failed to delete account. Please try again.");
    },
  });

  const popupDel = usePopup({
    onOk: () => {
      mutation.mutate();
    },
  });

  return (
    <div className="bg-white p-6">
      <div>
        <h2 className="text-xl font-bold">{t("Delete account")}</h2>
        <p className="mt-2 text-gray-700">
          {t("Are you sure you want to delete your account?")}
        </p>
        <ul className="ml-5 mt-3 list-disc space-y-2 text-sm text-gray-600">
          <li>
            {t("Once deleted, all personal and registered information will be removed.")}
          </li>
          <li>{t("Your current ID will be permanently deleted.")}</li>
          <li>
            {t("You will not be able to access order information after deletion.")}
          </li>
          <li>
            {t("Frequent deletion and recreation may lead to usage restrictions.")}
          </li>
        </ul>
        <div className="mt-4 flex items-center">
          <input
            type="checkbox"
            id="confirm"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
          />
          <label htmlFor="confirm" className="ml-2 text-sm text-gray-700">
            {t("I have reviewed all important information before deleting my account.")}
          </label>
        </div>
        <div className="mt-10">
          <button
            type="button"
            className="flex w-[9.875rem] flex-row items-center justify-center gap-[0.625rem] rounded-[99px] bg-[#232323] px-[1.25rem] py-[0.625rem] disabled:opacity-50"
            onClick={() => popupDel.open()}
            disabled={!isChecked || mutation.isLoading}
          >
            <span className="h-[1.375rem] text-center font-semibold leading-[1.375rem] text-[#FFFFFF]">
              {mutation.isLoading ? t("Deleting...") : t("Delete account")}
            </span>
          </button>
        </div>
      </div>
      {popupDel.isOpen && (
        <OkCancelPopup
          ic={icQuestion}
          title={t("Are you sure want to delete account?")}
          onOk={() => popupDel.onOk()}
          onCancel={() => popupDel.close()}
          okText={t("Delete")}
        />
      )}
    </div>
  );
}
